<template>
  <component
  @click="logDynamicData"
      :is="props.product.enableRedirection || props.landingPageUrl ? NuxtLinkWithLocale : 'div'"
      v-bind="linkAttrs"
      :id="props.id || `product-banner-${random_id}`"
      :class="twMerge(
          'ts-banner h-full relative font-gilroy rounded-lg overflow-hidden bg-[#2EB5CD]',
          (props.product?.enableRedirection || props.landingPageUrl) && 'inline-block'
      )"
      :style="root_styles"
  >
    <div class="w-full h-full pl-4 relative min-w-[336px] min-h-[170px] lg:min-w-[406px] lg:min-h-[434px] group/highlight-card">
      <TsMedia :append-class="twMerge(
          'h-full min-h-[inherit] lg:flex-col max-lg:items-center rounded-lg text-left items-stretch'
      )">
        <TsMediaContent append-class="pt-4 pb-5">
          <button
              v-if="props.clickAndCollectButton && props.clickAndCollectButton.label && props.clickAndCollectButton.label.text"
              class="flex items-center gap-2 text-white opacity-0 rounded-full group-hover/highlight-card:opacity-100 transition-all duration-300 bg-[#1094AC] border-[#52C9DF] absolute top-2 right-2 p-2 text-xs leading-[10px]"
              size="xs" rounded :style="click_and_collect_button_styles">
              <TsCursorIcon width="16" />
          </button>
          <TsImage
              v-if="props.brandLogo && props.brandLogo.src"
              :src="props.brandLogo.src"
              :alt="props.brandLogo.alt || 'banner card brand logo'"
              class="lg:mb-5 lg:mt-8"
              width="101"
              height="23"
              loading="lazy"
          />

          <div
              :class="twMerge('lg:text-4xl max-md:text-xl font-semibold text-idle-white leading-tight line-clamp-3 mb-1.5')"
              :style="title_styles"
              v-html="(props.product && props.product.enableTitle && product_data && product_data?.full_name) ? product_data?.full_name : props.title?.text">
          </div>

          <div
              :class="twMerge('lg:text-[20px] max-md:text-[12px] font-semibold text-white leading-none line-clamp-2')"
              :style="description_styles"
              v-html="(props.product && props.product.enableDescription && product_data && product_data?.description
) ? product_data?.description
 : props.description?.text">
          </div>

          <button
              v-if="props.button && props.button.label && props.button.label.text"
              class="bg-primary text-white lg:text-[18px] max-md:text-[14px]  leading-[20px] mt-4 font-semibold  rounded-md px-4 py-2"
              :style="button_styles"
          >
            {{ props.button.label.text }}
          </button>
        </TsMediaContent>
        <TsMediaEnd v-if="props.image && props.image.src" append-class="flex items-end shrink">
          <TsImage class="mt-auto  lg:w-[266px] lg:h-[195px] max-md:w-[204px] max-md:h-[134px]"
                   :src="props.image.src"  :alt="props.image.alt || 'banner card product image'" loading="lazy"
          />
        </TsMediaEnd>
      </TsMedia>
    </div>
  </component>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";


const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

const TsMediaEnd = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaEnd.vue')
);



const TsCursorIcon = defineAsyncComponent(
    () => import('~/components/atoms/icons/TsCursorIcon.vue')
);

type Props = {
  id?: string;
  dataTestid?: string;
  landingPageUrl?: string;
  product?: object;
  image?: object;
  brandLogo?: object;
  title?: object;
  description?: object;
  button?: object;
  clickAndCollectButton?: object;
  backgroundGradientColor?: object;
  backgroundColor?: object;
  backgroundImage?: string;
}

const props = withDefaults(defineProps<Props>(), {
  // dataTestid: 'highlights',
  // image: () => ({
  //   src: '/images/makita-tool.png'
  // }),
  // brandLogo: () => ({
  //   src: '/images/logos/makita.svg'
  // }),
  // title: () => ({
  //   text: 'Avail benefits <br /> up to €199.00'
  // }),
  // description: () => ({
  //   text: 'Cordless Drill'
  // }),
  // button: () => ({
  //   label: 'Know More'
  // }),
  // clickAndCollectButton: () => ({
  //   label: {
  //     text: 'CLICK & VIEW'
  //   }
  // })
})

const random_id = ref('');
const product_id = computed(() => props.product?.id);
const product_data = ref(null);

const NuxtLinkWithLocale = resolveComponent('NuxtLinkWithLocale');
const linkAttrs = computed(() => ({
  ...(props.landingPageUrl && {to: props.landingPageUrl}),
  ...(props.product?.enableRedirection && {to: getProductSlug(product_data.value?.slug, product_data.value?.code)}),
}))

const title_styles = computed(() => ({
  ...(props.title?.color && {color: props.title?.color}),
  ...(props.title?.fontSize && {fontSize: props.title?.fontSize})
}))

const description_styles = computed(() => ({
  ...(props.description?.color && {color: props.description?.color}),
  ...(props.description?.fontSize && {fontSize: props.description?.fontSize}),
}))

const button_styles = computed(() => ({
  ...(props.button.label?.color && {color: props.button?.label?.color}),
  ...(props.button.label?.custom && {color: props.button?.label?.custom}),
  ...(props.button.label?.fontSize && {fontSize: props.button?.label?.fontSize}),
  ...(props.button.background?.color && {backgroundColor: props.button?.background?.color}),
  ...(props.button.background?.custom && {backgroundColor: props.button?.background?.custom}),
  ...((props.button?.marginTop || props.button?.marginTop === 0) && {marginTop: `${props.button.marginTop}px`}),
}))

const click_and_collect_button_styles = computed(() => ({
  ...(props.clickAndCollectButton.label?.color && {color: props.clickAndCollectButton?.label?.color}),
  ...(props.clickAndCollectButton.label?.custom && {color: props.clickAndCollectButton?.label?.custom}),
  ...(props.clickAndCollectButton.label?.fontSize && {fontSize: props.clickAndCollectButton?.label?.fontSize}),
  ...(props.clickAndCollectButton.background?.color && {backgroundColor: props.clickAndCollectButton?.background?.color}),
  ...(props.clickAndCollectButton.background?.custom && {backgroundColor: props.clickAndCollectButton?.background?.custom}),
  ...(props.clickAndCollectButton.borderColor?.color && {border: `1px solid ${props.clickAndCollectButton?.borderColor?.color}`}),
  ...(props.clickAndCollectButton.borderColor?.custom && {border: `1px solid ${props.clickAndCollectButton?.borderColor?.custom}`}),
}))

const root_styles = computed(() => ({
  ...(props.backgroundColor?.color && {backgroundColor: props.backgroundColor.color }),
  ...(props.backgroundColor?.custom && {backgroundColor: props.backgroundColor.custom }),
  ...(props.backgroundImage && { backgroundImage: `url(${props.backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }),
}))


const getProductData = async (id) => {
  const data = await useAjaxEcom(
      '/products/getProducts',
      {
        method: 'post',
        params: {
          "products": [`${id}`]
        }
      }
  );

  return data?.data[0];
}

onMounted(async () => {
  random_id.value = useRandomUUID();
  if(props.product?.id) {
    product_data.value = await getProductData(product_id.value);
    bannerView(product_data?.value,"banner card")
  }
});

const stopBannerProductCodeWatcher = watch(product_id, async () => {
  if(!props.product?.id) return;
  product_data.value = await getProductData(product_id.value);
})
// GTM Log FOR banner click
const logDynamicData = () => {
  bannerClick(product_data?.value, "banner card")
};

onUnmounted(() => {
  stopBannerProductCodeWatcher();
})
</script>
